import { ActionReducerMap } from '@ngrx/store';
import { logoReducer } from '@store/reducer/logo.reducer';
import { themeReducer } from '@store/reducer/theme.reducer';
import { LogoState, SessionState, ThemeState } from '@store/entities';
import { sessionReducer } from '@store/reducer/session.reducer';

export interface AppState {
  logo: LogoState;
  theme: ThemeState;
  session: SessionState;
}

export const ROOT_REDUCERS: ActionReducerMap<AppState> = {
  logo: logoReducer,
  theme: themeReducer,
  session: sessionReducer,
};
